import axios from "axios"
import { all, fork, takeLatest, call, put } from "redux-saga/effects"
import { API_BASE_URL } from "../constants/config"
import actionTypes from "../constants/actionTypes"

// ========== 게시판 목록 조회 ==========
function* fetchBoard(action) {
    try {
        const { menuId, page, size, search } = action.payload

        const params = {
            menuId,
            page,
            size,
        }

        if (search) {
            params.search = search
        }


        const response = yield call(axios.get, `${API_BASE_URL}/board/contents`, {
            params,
        })


        yield put({
            type: actionTypes.BOARD_FETCH_SUCCEED,
            payload: {
                ...response.data,
                menuId, // 메뉴 ID를 포함해서 전달
            },
        })
    } catch (error) {
        console.error("게시판 목록 API 오류:", error)
        yield put({
            type: actionTypes.BOARD_FETCH_FAILED,
            payload: {
                menuId: action.payload.menuId,
                error: error.response?.data?.message || error.message,
            },
        })
    }
}

// ========== 게시판 상세 조회 ==========
function* fetchBoardDetail(action) {
    try {
        const { id } = action.payload


        const response = yield call(axios.get, `${API_BASE_URL}/board/contents/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        })


        yield put({
            type: actionTypes.BOARD_DETAIL_FETCH_SUCCEED,
            payload: response.data,
        })
    } catch (error) {
        console.error("게시판 상세 조회 API 오류:", error)

        yield put({
            type: actionTypes.BOARD_DETAIL_FETCH_FAILED,
            payload: error.response?.data?.message || "게시판 정보를 불러오는데 실패했습니다.",
        })
    }
}

// ========== 게시판 상세 정보 초기화 ==========
function* resetBoardDetail(action) {
    try {
        // reducer에서 처리되므로 여기서는 아무것도 하지 않음
    } catch (error) {
        console.error("게시판 상세 정보 초기화 오류:", error)
    }
}

// ========== 게시판 등록 ==========
function* writeBoard(action) {
    try {
        const { boardId, title, contents, createId } = action.payload

        const requestData = {
            boardId,
            title,
            contents,
            createId,
        }

        const token = localStorage.getItem('token');

        const response = yield call(axios.post, `${API_BASE_URL}/admin-web/board/content`, requestData, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': "Bearer " +`${token}`
            },
            timeout: 30000, // 30초 타임아웃
        })


        yield put({
            type: actionTypes.BOARD_WRITE_SUCCEED,
            payload: response.data,
        })
    } catch (error) {
        console.error("=== SAGA: 게시판 등록 실패 ===")
        console.error("에러 상세:", {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: error.config,
        })

        let errorMessage = "저장 중 오류가 발생했습니다."

        if (error.code === "NETWORK_ERROR" || !error.response) {
            errorMessage = "네트워크 연결을 확인해주세요."
        } else if (error.response?.status === 404) {
            errorMessage = "API 엔드포인트를 찾을 수 없습니다."
        } else if (error.response?.status >= 500) {
            errorMessage = "서버 오류가 발생했습니다."
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message
        }

        yield put({
            type: actionTypes.BOARD_WRITE_FAILED,
            payload: errorMessage,
        })
    }
}

// ========== 게시판 수정 ==========
function* updateBoard(action) {
    try {
        const { boardId, title, contents, updateId } = action.payload

        // 백엔드 API 스펙에 맞게 RequestBody 구성
        const requestData = {
            boardId,
            title,
            contents,
            updateId,
        }

        const token = localStorage.getItem('token');

        const response = yield call(axios.put, `${API_BASE_URL}/admin-web/board/content`, requestData, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': "Bearer " +`${token}`
            },
        })

        yield put({
            type: actionTypes.BOARD_UPDATE_SUCCEED,
            payload: response.data,
        })
    } catch (error) {
        console.error("=== SAGA: 게시판 수정 실패 ===")
        console.error("에러 상세:", {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: error.config,
        })

        let errorMessage = "수정 중 오류가 발생했습니다."

        if (error.code === "NETWORK_ERROR" || !error.response) {
            errorMessage = "네트워크 연결을 확인해주세요."
        } else if (error.response?.status === 404) {
            errorMessage = "수정할 게시물을 찾을 수 없습니다."
        } else if (error.response?.status === 403) {
            errorMessage = "수정 권한이 없습니다."
        } else if (error.response?.status >= 500) {
            errorMessage = "서버 오류가 발생했습니다."
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message
        }

        yield put({
            type: actionTypes.BOARD_UPDATE_FAILED,
            payload: errorMessage,
        })
    }
}

// ========== 게시판 삭제 ==========
function* deleteBoard(action) {
    try {
        const { boardId, id } = action.payload

        // 백엔드 API 스펙에 맞게 RequestBody로 boardId 전달
        const requestData = {
            boardId: boardId || id, // boardId가 없으면 id를 사용
        }
        const token = localStorage.getItem('token');

        const response = yield call(axios.delete, `${API_BASE_URL}/admin-web/board/content`, {
            data: requestData, // DELETE 요청에서 body 데이터는 data 속성으로 전달
            headers: {
                "Content-Type": "application/json",
                'Authorization': "Bearer " +`${token}`
            },
        })


        yield put({
            type: actionTypes.BOARD_DELETE_SUCCEED,
            payload: {
                boardId: requestData.boardId,
                id: id,
                ...response.data,
            },
        })
    } catch (error) {
        console.error("=== SAGA: 게시판 삭제 실패 ===")
        console.error("에러 상세:", {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: error.config,
        })

        let errorMessage = "삭제 중 오류가 발생했습니다."

        if (error.code === "NETWORK_ERROR" || !error.response) {
            errorMessage = "네트워크 연결을 확인해주세요."
        } else if (error.response?.status === 404) {
            errorMessage = "삭제할 게시물을 찾을 수 없습니다."
        } else if (error.response?.status === 403) {
            errorMessage = "삭제 권한이 없습니다."
        } else if (error.response?.status >= 500) {
            errorMessage = "서버 오류가 발생했습니다."
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message
        }

        yield put({
            type: actionTypes.BOARD_DELETE_FAILED,
            payload: {
                boardId: action.payload.boardId || action.payload.id,
                error: errorMessage,
            },
        })
    }
}

// ========== Watcher 함수들 ==========
function* watchFetchBoard() {
    yield takeLatest(actionTypes.BOARD_FETCH, fetchBoard)
}

function* watchFetchBoardDetail() {
    yield takeLatest(actionTypes.BOARD_DETAIL_FETCH, fetchBoardDetail)
}

function* watchResetBoardDetail() {
    yield takeLatest(actionTypes.BOARD_DETAIL_RESET, resetBoardDetail)
}

function* watchWriteBoard() {
    yield takeLatest(actionTypes.BOARD_WRITE, writeBoard)
}

function* watchUpdateBoard() {
    yield takeLatest(actionTypes.BOARD_UPDATE, updateBoard)
}

function* watchDeleteBoard() {
    yield takeLatest(actionTypes.BOARD_DELETE, deleteBoard)
}

// ========== 메인 사가 ==========
export default function* boardSaga() {
    yield all([
        fork(watchFetchBoard),
        fork(watchFetchBoardDetail),
        fork(watchResetBoardDetail),
        fork(watchWriteBoard),
        fork(watchUpdateBoard),
        fork(watchDeleteBoard),
    ])
}
